import ConditionalLoader from '@Guidelines/Component/Loader/ConditionalLoader';
import { theme } from '@Guidelines/Theme/theme';
import type TranscriptionIssueView from '@UI/Store/WorkflowRuns/Views/TranscriptionIssueView';
import { css } from '@emotion/react';
import type * as React from 'react';

const noteStyle = css`
	margin: 0;
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.medium};
	color: ${theme.colors.inkSecondary};
`;

type Props = {
	readonly issue: TranscriptionIssueView;
};

/** After a failed speaker separation the transcript stays usable: reassures the reader. */
const SpeakerFailureOrientation: React.FC<Props> = ({ issue }) => {
	const isSpeakerFailure = issue.step.value === 'speaker_separation' && !issue.isStalled;

	return (
		<ConditionalLoader data={isSpeakerFailure}>
			<p css={noteStyle}>Le transcript reste lisible et corrigeable, sans nom de locuteur.</p>
		</ConditionalLoader>
	);
};

export default SpeakerFailureOrientation;
